<template>
  <base-section id="ifea-info">
    <base-section-heading title="IFEA TREUHAND GMBH">
      In Finanzen Eins A – bei uns sind Sie in besten Händen. Als zuverlässige Treuhandfirma bieten wir Ihnen professionelle und massgeschneiderte Dienstleistungen in den Bereichen Buchhaltung, Steuern, Unternehmensberatung und Personalwesen. Wir zeichnen uns durch grosse Leistungsbereitschaft, Flexibilität und hohe Fachkompetenz aus. Durch gezielte Weiterbildung garantieren wir die bestmögliche Beratung und Unterstützung. Vertrauen Sie auf unser Know-how und unsere Professionalität um Ihre Geschäftsfinanzen zu optimieren und Ihre Steuerlast zu minimieren.
      <br>Wir freuen uns auf Sie.
    </base-section-heading>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionIfeaInfo',

    data: () => ({
    }),
  }
</script>
